import { render, staticRenderFns } from "./Projectcost.vue?vue&type=template&id=618cc8d3&scoped=true&"
import script from "./Projectcost.vue?vue&type=script&lang=js&"
export * from "./Projectcost.vue?vue&type=script&lang=js&"
import style0 from "./Projectcost.vue?vue&type=style&index=0&id=618cc8d3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618cc8d3",
  null
  
)

export default component.exports